import React, { useContext, useEffect } from 'react';

import { CertificatesContext } from '../../contexts/certificates.context';
import Button from '../../common/Buttons/Button';

import './certificates.style.scss';

import './certificates.style.scss';

/**
 * Модалка сертифіката: що потрібно, скільки вже є і чому формат саме такий.
 *
 * ❗Нічого не рахує — усі тексти приходять з CRM готовими. Це навмисно:
 * формулювання в кабінеті й у CRM мусять збігатися дослівно, інакше студент
 * і менеджер бачитимуть різні пояснення тих самих умов.
 *
 * Рендериться ОДИН раз на сторінку курсів, а не в кожному рядку.
 */
const CertificateModal = () => {
  const {
    byProgram,
    openProgram,
    setOpenProgram,
    issue,
    download,
    busy,
    error,
    notice,
    clearMessages,
  } = useContext(CertificatesContext);

  const item = openProgram === null ? null : byProgram[openProgram.id] ?? null;
  const isOpen = openProgram !== null;

  // Escape і блокування скролу — модалка на всю висоту, без цього фон
  // «підʼїжджає» під пальцем на телефоні.
  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        setOpenProgram(null);
      }
    };

    document.addEventListener('keydown', onKeyDown);
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = '';
    };
  }, [isOpen, setOpenProgram]);

  if (!isOpen) {
    return null;
  }

  const close = () => {
    clearMessages();
    setOpenProgram(null);
  };

  // ❗Стану може не бути: CRM не повернула цей курс (немає правил для такої
  // тривалості, курс іще не почався) або запит по сертифікатах узагалі впав.
  // Показуємо це прямо, а не порожньою модалкою.
  if (item === null) {
    return (
      <div className="modal-info certificate-modal open">
        <div className="overlay" onClick={close}></div>

        <div className="modal-info__container certificate-modal__container">
          <button
            type="button"
            className="certificate-modal__close"
            onClick={close}
            aria-label="Закрити"
          >
            ×
          </button>

          <div className="certificate-modal__head">
            <h2 className="certificate-modal__title">Сертифікат</h2>
            {openProgram.title && (
              <p className="certificate-modal__course">{openProgram.title}</p>
            )}
          </div>

          {/* Той самий зміст, що й `StudentCertificate::NOT_READY_TEXT` у CRM:
              студенту байдуже, чому саме стан не прийшов — для нього це
              означає рівно одне, що сертифікат ще не готовий. */}
          <p className="certificate-modal__summary">
            Ви ще не виконали всі умови отримання сертифіката.
          </p>

          {error && <p className="certificate-modal__error">{error}</p>}
        </div>
      </div>
    );
  }

  const { certificates = [] } = item;

  return (
    <div className="modal-info certificate-modal open">
      <div className="overlay" onClick={close}></div>

      <div className="modal-info__container certificate-modal__container">
        <button type="button" className="certificate-modal__close" onClick={close} aria-label="Закрити">
          ×
        </button>

        <div className="certificate-modal__head">
          <h2 className="certificate-modal__title">Сертифікат</h2>
          <p className="certificate-modal__course">{item.title}</p>
        </div>

        {/* pre-line: у вітальному тексті два абзаци, розділені \n\n */}
        <p className="certificate-modal__summary">{item.summary}</p>

        {/* Кожен документ качається окремо: по курсу їх може бути кілька —
            самовиданий і ті, що менеджер зробив іншими шаблонами. */}
        {certificates.length > 0 && (
          <ul className="certificate-issued">
            {certificates.map((certificate) => (
              <li key={certificate.id} className="certificate-issued__item">
                <span className="certificate-issued__info">
                  <b>{certificate.number}</b>
                  <span>від {certificate.issued_date}</span>
                </span>
                <button
                  type="button"
                  className="certificate-issued__link"
                  disabled={busy}
                  onClick={() => download(certificate)}
                >
                  Завантажити
                </button>
              </li>
            ))}
          </ul>
        )}

        {error && <p className="certificate-modal__error">{error}</p>}
        {notice && <p className="certificate-modal__notice">{notice}</p>}

        {/* Головна кнопка — тільки для видачі. Завантаження живе в рядках
            списку вище, бо документів може бути кілька і треба обрати. */}
        {item.can_issue && (
          <div className="certificate-modal__actions">
            <Button
              buttonBg="violet"
              loading={busy ? '...' : ''}
              disabled={busy}
              onClick={() => issue(item.program_id)}
            >
              Отримати сертифікат
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CertificateModal;
